export default __webpack_public_path__ + "static/media/banner8.2d8c05b5.jpg";